import { AvailablePrinter } from '@/modules/printModule/services/anapath-printer-rest-client/anapath-printer-rest-client.model'

export enum ReportModelEnum {
    // General
    REPORTS = 'REPORTS',
    CASE_LABEL = 'CASE_LABEL',
    SAMPLE_LABEL = 'SAMPLE_LABEL',
    SUBREQUEST_LABEL = 'SUBREQUEST_LABEL',
    CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL = 'CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL',
    PRINTMATE_CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL = 'PRINTMATE_CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL',
    SUBPORTION_SLIDE_LABEL = 'SUBPORTION_SLIDE_LABEL',
    // by Sample Type
    CYTOLOGY_SAMPLE_LABEL = 'CYTOLOGY_SAMPLE_LABEL'
    // by Assay_AssayGroup
}

/**
 * Object that represents a user printing report model configuration data for updating
 */
export interface UserappReportModelConfigurationRequest {
    id?: number // User report model configuration id
    reportModel?: ReportModelEnum // Report model to configure.
    /**
     * Printer name encoded in base64.
     * Encoded to avoid problems with native printer name of printer in different S.O.
     * It is necessary to send report to correct printer in Anapath Printer software.
     */
    encodedPrinterName?: string
    copies?: number // Default number of copies for each model.
    printerId?: number // Printer id
    path?: string // path needed for some printers where they will read the files to be printed
}

/**
 * Object that represents a user report model configuration for printing.
 * This configuration must match a local user printer for the combination of a report model and a laboratory printer.
 */
export interface UserappReportModelConfigurationResponse extends UserappReportModelConfigurationRequest {}

///

/**
 * Object that represents a printer, it is a physical machine in the laboratory, not means a user's configured printer.
 * Content to be shown in user printers configuration section.
 */
export interface PrinterConfigurationResponse {
    id: number // Printer id
    name: string // Printer's name (Trademark, model or any other name known by members in the laboratory)
}

/**
 * Object that represents a report model configuration.
 * Content to be shown in user printers configuration section.
 */
export interface ReportModelConfigurationResponse {
    id: number // Report model configuration id
    laboratoryId: number // laboratory id to show only related configuration for logged laboratory in.
    reportModel: ReportModelEnum // Report model, used for returning with related printer when configured.
    translatedReportModelName: string // Each report model has a translatable name for displaying to the user.
    /**
     * Is default report (true = 1) or report model (false = 0) configuration?
     * It is just to separate configurations when showing to user.
     * No functional purpose.
     */
    isDefault: boolean
    sortOrder: number // It is the position for displaying to the user.
    printer?: PrinterConfigurationResponse // Printer association when available.
}

///

export interface ReportModelConfigurationMatch
    extends ReportModelConfigurationResponse,
        Pick<UserappReportModelConfigurationResponse, 'copies' | 'path'> {
    userReportModelConfigurationId?: number
    selectedPrinter?: AvailablePrinter
}
